import React from 'react';

const FooterWrapper = ()=>{
    return(
        <div id="footer-container">
                <div id="textfooter1">
                    <a target="_blank" href="https://vedavishtaram.in/" rel="noreferrer">
                        <pre>© 2024-2026 vedictools.in by vedavishtaram.in</pre>
                    </a>
                </div>
        </div>
    )
}

export default FooterWrapper;